<script>
export default {
    props: {
        linkedMarketplaceProduct: {
            default: null,
        }
    },
    data() {
        return {
            showLoading: false,
            form: {},
            formatedForm: []
        };
    },
    mounted() {
        this.reset()
    },
    watch: {
        linkedMarketplaceProduct() {
            if (this.linkedMarketplaceProduct != null && this.linkedMarketplaceProduct.id != undefined) {
                this.form.id = this.linkedMarketplaceProduct.id
                this.form.quantity = this.linkedMarketplaceProduct.quantity
                this.form.selling_price = Math.floor(this.linkedMarketplaceProduct.selling_price)
                this.form.discounted_type = this.linkedMarketplaceProduct.discounted_type
                this.form.discounted_price = Math.floor(this.linkedMarketplaceProduct.discounted_price)
                // this.form.marketplace_status = (this.linkedMarketplaceProduct.marketplace_status == "BUYABLE") ? true : false

            }
        },
        form: {
            handler(val) {
                if (this.form.length > 0) {
                    if (this.form.discounted_type != undefined && this.form.discounted_type == "amount" && this.form.discount_value > 0)
                        this.form.discounted_price = this.form.selling_price - this.form.discount_value
                    if (this.form.discounted_type != undefined && this.form.discounted_type == "percentage" && this.form.discount_value > 0)
                        this.form.discounted_price = this.form.selling_price * ((100 - this.form.discount_value) / 100)
                    if (this.form.discounted_type == "" || this.form.discount_value == "")
                        this.form.discounted_price = Math.floor(this.linkedMarketplaceProduct.discounted_price)
                }
            },
            deep: true
        }
    },
    methods: {
        submit() {

            this.$emit("handleLinkedMarketplaceProductUpdate", this.form);
        },
        reset() {
            this.form = {}
        }
    },
};
</script>

<template>
    <div class="modal fade" tabindex="-1" id="edit_marketplace_linked_product" rel="">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">

                    <!--begin::Close-->
                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" id="close" data-bs-dismiss="modal"
                        aria-label="Close">
                        <span class="svg-icon svg-icon-2x">X</span>
                    </div>
                    <!--end::Close-->
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-4">
                            <h2>
                                {{ $t('bulkProductPriceManagment') }}
                            </h2>
                        </div>
                        <div class="col-md-8">
                            <div class="d-flex justify-content-end"><!--begin::Button--><a data-bs-dismiss="modal"
                                    aria-label="Close" data-kt-contacts-type="cancel" class="btn btn-light me-3">{{
                                        $t('cancel') }}</a><!--end::Button--><!--begin::Button--><button type="submit"
                                    @click="submit" data-kt-contacts-type="submit" class="btn btn-primary btn-app"
                                    data-text="إضافة تصنيف"><span class="indicator-label">{{ $t('save') }}</span><span
                                        class="indicator-progress">{{ $t('pleaseWait') }}<span
                                            class="spinner-border spinner-border-sm align-middle ms-2"></span></span></button><!--end::Button-->
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="linkedMarketplaceProduct != null">
                        <div class="col-xl-3 col-lg-4">
                            <div class="card mb-5">
                                <div class="card card-body">
                                    <div class="col-md-12">
                                        <div class="text-center">
                                            <img class="product-img" :src="linkedMarketplaceProduct?.Thumbnail" />
                                        </div>
                                        <p class="mb-2 mt-3 sku-number-styles fs-5"><span class="sku-number">{{
                                            linkedMarketplaceProduct?.sku }}</span><span class="sku-header">{{ $t('sku')
    }}</span></p>
                                        <h2 class="fs-4 mb-4">{{ linkedMarketplaceProduct?.product?.sku }}</h2>
                                        <p class="pt-4 border-top">{{ linkedMarketplaceProduct?.product?.title }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card card-body">
                                    <div class="col-md-12">
                                        <table class="w-100">
                                            <tr>
                                                <th class="fw-light">{{ $t('sku') }}</th>
                                                <td class="text-end text-black fw-bolder">{{
                                                    linkedMarketplaceProduct?.product?.sku }}</td>
                                            </tr>
                                            <tr>
                                                <th class="fw-light">{{ $t('identifierType') }}</th>
                                                <td class="text-end text-black fw-bolder">{{
                                                    linkedMarketplaceProduct?.identifier_type }}</td>
                                            </tr>
                                            <tr>
                                                <th class="fw-light">{{ $t('identifierValue') }}</th>
                                                <td class="text-end text-black fw-bolder">{{
                                                    linkedMarketplaceProduct?.identifier_value }}</td>
                                            </tr>
                                            <tr
                                                v-for="option, index in linkedMarketplaceProduct?.linkedMarketplaceProduct?.option_values">
                                                <th class="fw-light">{{ option.option.title }}</th>
                                                <td class="text-end text-black fw-bolder">{{ option.title }}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-9 col-lg-8">
                            <div class="card mb-10">
                                <div class="card-header align-content-center" type="button" data-bs-toggle="collapse"
                                    :data-bs-target="'#collapse' + index" aria-expanded="false">
                                    <h2 class="mb-0 d-inline fs-2 lh-xl"><img alt="Logo"
                                            src="assets/media/svg/brand-logos/amazon.svg" class="h-35px me-3" />{{
                                                option?.marketplace?.name }}</h2>
                                </div>

                                <div class="card-body">

                                    <div class="row py-3">
                                        <div class="col-md-6">
                                            <div class="form-group mb-4">
                                                <label for="_6541f8444bfed" class=" form-label">{{ $t('quantity') }}</label>
                                                <input class="form-control" name="quantity" v-model="form.quantity"
                                                    type="number">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group mb-4">
                                                <label for="_6541f8444bfed" class=" form-label">{{ $t('price') }}</label>
                                                <input class="form-control" name="selling_price"
                                                    v-model="form.selling_price" type="number">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group mb-4">
                                                <label for="_6541f8444bfed" class=" form-label">{{ $t('discountType')
                                                }}</label>
                                                <select class="form-control" name="discount_type"
                                                    v-model="form.discounted_type">
                                                    <option value="amount">{{ $t('amount') }}</option>
                                                    <option value="percentage">{{ $t('percentage') }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group mb-4">
                                                <label for="_6541f8444bfed" class=" form-label">{{ $t('discountValue')
                                                }}</label>
                                                <input class="form-control" name="discount_value"
                                                    v-model="form.discount_value" type="number">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group mb-4">
                                                <label for="_6541f8444bfed" class=" form-label">{{ $t('priceAfterDiscount')
                                                }}</label>
                                                <input class="form-control" name="discounted_price" disabled
                                                    v-model="form.discounted_price" type="number">
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-12">
                                            <label class="form-check form-switch form-check-custom form-check-solid">
                                                <span class="form-check-label fw-semibold text-muted">
                                                    {{ $t('productAvailable') }}
                                                </span>
                                                <input class="form-check-input" type="checkbox"
                                                    v-model="form.marketplace_status">
                                            </label>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
/* #edit_product .modal-dialog {
    max-width: 80%;
} */
.modal-body .plus-icon-container {
    display: none !important;
}

.modal-body .product-img {
    max-width: 100%;
}

.modal-body .collapsed .plus-icon-container {
    display: inline-flex !important;
}

.modal-body .minus-icon-container {
    display: inline-flex !important;
}

.modal-body .collapsed .minus-icon-container {
    display: none !important;
}

.modal-body .plus-icon-container {
    background-color: #fff;
    width: 40px;
    height: 40px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 20px;
}

.modal-body .card .card-body,
.modal-body .card .card-header {
    padding: 1rem 1.15rem !important;

}

.modal-body .plus-icon {
    fill: rgba(88, 88, 88, 0.9);
}

.modal-body .minus-icon-container {
    background-color: rgba(236, 85, 47, 0.1);
    width: 40px;
    height: 40px;
    border-radius: 5px;
    display: none;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 20px;
}

.modal-body .minus-icon {
    fill: #ec552f;
}

.modal-body .card {
    border: 1px solid #eff2f5;
}

.modal-body .collapsed.card-header {
    border-bottom: unset;
}

.modal-body .form-check.form-check-custom {
    justify-content: space-between;
}

.modal-body .card-header {
    border-bottom: 1px solid #eff2f5;
}

.sku-number-styles {
    direction: ltr;
    text-align: end;
}

.sku-number-styles .sku-number {
    color: #ec552f;
}

.pt-4.border-top {
    border-top-style: dashed !important;
}

.form-switch.form-check-solid .form-check-input {
    height: 2.25rem;
}

.form-switch .form-check-input:checked {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e") !important;
}

.form-check.form-check-solid .form-check-input:checked,
input:checked[type="radio"]:not(.reflex) {

    background-color: #ec552f !important;
}
</style>
